<template>
    <mm-select :options="list" 
    v-bind="$attrs" :value="value" v-on="$listeners"/>
</template>

<script>
export default {
	data(){
		return {
			list:[
                { value: true, label: 'TRUE' },
                { value: { $nin: true }, label: 'FALSE' },
            ],
		}
	},
	props:['value'],
}
</script>